var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 71,
    viewBox: "0 0 62 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 11.1875V17.75C61.25 23.9023 47.4414 28.6875 30.625 28.6875C13.6719 28.6875 0 23.9023 0 17.75V11.1875C0 5.17188 13.6719 0.25 30.625 0.25C47.4414 0.25 61.25 5.17188 61.25 11.1875ZM53.7305 29.6445C56.6016 28.6875 59.1992 27.3203 61.25 25.8164V39.625C61.25 45.7773 47.4414 50.5625 30.625 50.5625C13.6719 50.5625 0 45.7773 0 39.625V25.8164C1.91406 27.3203 4.64844 28.6875 7.38281 29.6445C13.5352 31.832 21.7383 33.0625 30.625 33.0625C39.375 33.0625 47.5781 31.832 53.7305 29.6445ZM0 47.6914C1.91406 49.1953 4.64844 50.5625 7.38281 51.5195C13.5352 53.707 21.7383 54.9375 30.625 54.9375C39.375 54.9375 47.5781 53.707 53.7305 51.5195C56.6016 50.5625 59.1992 49.1953 61.25 47.6914V59.3125C61.25 65.4648 47.4414 70.25 30.625 70.25C13.6719 70.25 0 65.4648 0 59.3125V47.6914Z",
    fill: "#01318D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.64d31ac21608c58f96233c16d462de2b.svg";
export { ForwardRef as ReactComponent };